<template>
  <div class="home-center-wrapper">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" color="#0096Ab"></v-progress-circular>
    </v-overlay>
    
    <div v-if="!overlay">
      <!-- Page Title Section -->
      <div class="page-header">
        <div class="title-container">
          <div class="title-icon">
            <v-icon size="36" color="#ffffff">mdi-safe</v-icon>
          </div>
          <h1 class="page-title">الصناديق</h1>
          <div class="title-divider"></div>
        </div>
        <p class="page-subtitle">نظرة عامة على الوضع المالي والصناديق</p>
      </div>

      <!-- Financial Boxes -->
      <v-row class="financial-boxes" no-gutters>
        <!-- Main Treasury Box -->
        <v-col cols="4">
          <div class="box-container">
            <v-card 
              elevation="8" 
              class="modern-box main-box" 
              rounded="xl"
            >
              <div class="box-header">
                <div class="icon-wrapper main-icon">
                  <v-icon size="28" color="white">mdi-package</v-icon>
                </div>
                <h3 class="box-title">الصندوق الرئيسي</h3>
              </div>
              
              <div class="amount-display">
                <h2 class="amount-text main-amount">
                  {{
                    (income - expenses).toLocaleString("en-US", {
                      style: "currency",
                      currency: "IQD",
                    })
                  }}
                </h2>
              </div>
              
              <div class="box-footer">
                <span class="balance-label">الرصيد الحالي</span>
              </div>
            </v-card>
          </div>
        </v-col>

        <!-- Income Box -->
        <v-col cols="4">
          <div class="box-container">
            <v-card 
              elevation="8" 
              class="modern-box income-box" 
              rounded="xl"
            >
              <div class="box-header">
                <div class="icon-wrapper income-icon">
                  <v-icon size="28" color="white">mdi-trending-up</v-icon>
                </div>
                <h3 class="box-title">إجمالي الإيرادات</h3>
              </div>
              
              <div class="amount-display">
                <h2 class="amount-text income-amount">
                  {{
                    (income * 1).toLocaleString("en-US", {
                      style: "currency",
                      currency: "IQD",
                    })
                  }}
                </h2>
              </div>
              
              <div class="box-footer">
                <span class="balance-label">المقبوضات</span>
              </div>
            </v-card>
          </div>
        </v-col>

        <!-- Expenses Box -->
        <v-col cols="4">
          <div class="box-container">
            <v-card 
              elevation="8" 
              class="modern-box expenses-box" 
              rounded="xl"
            >
              <div class="box-header">
                <div class="icon-wrapper expenses-icon">
                  <v-icon size="28" color="white">mdi-trending-down</v-icon>
                </div>
                <h3 class="box-title">إجمالي المصروفات</h3>
              </div>
              
              <div class="amount-display">
                <h2 class="amount-text expenses-amount">
                  {{
                    (expenses * 1).toLocaleString("en-US", {
                      style: "currency",
                      currency: "IQD",
                    })
                  }}
                </h2>
              </div>
              
              <div class="box-footer">
                <span class="balance-label">المدفوعات</span>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    income: 0,
    expenses: 0,
    overlay: true,
  }),
  created() {
    let self = this;
    self.$http
      .get(`${self.$store.state.apiUrl}/statistics`, {
        headers: { Authorization: `Bearer ${self.$store.state.user}` },
      })
      .then((res) => {
        self.income = res.data.income;
        self.expenses = res.data.expenses;
        self.overlay = false;
      })
      .catch((err) => {
        self.overlay = false;
      });
  },
};
</script>

<style scoped>
.home-center-wrapper {
  padding: 20px;
}

/* Page Header Styles */
.page-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 32px 0;
  position: relative;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
  position: relative;
}

.title-icon {
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 150, 171, 0.3);
  position: relative;
}

.title-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
  border-radius: 20px;
  pointer-events: none;
}

.page-title {
  font-size: 42px;
  font-weight: 800;
  margin: 0;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px rgba(0, 150, 171, 0.1);
  letter-spacing: 2px;
}

.title-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  border-radius: 2px;
  position: relative;
}

.title-divider::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  background: #00BCD4;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(0, 188, 212, 0.3);
}

.page-subtitle {
  font-size: 18px;
  color: #6B7280;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.financial-boxes {
  margin: 0 -8px;
}

.box-container {
  padding: 0 8px;
}

.modern-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  min-height: 180px;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.modern-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1) !important;
}

.main-box {
  border-top: 4px solid #10B981;
}

.income-box {
  border-top: 4px solid #3B82F6;
}

.expenses-box {
  border-top: 4px solid #EF4444;
}

.box-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 24px 16px 24px;
}

.icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.main-icon {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
}

.income-icon {
  background: linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%);
}

.expenses-icon {
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);
}

.box-title {
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  flex: 1;
  min-width: 0;
}

.amount-display {
  padding: 16px 24px;
  text-align: center;
}

.amount-text {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  word-break: break-word;
}

.main-amount {
  color: #10B981;
}

.income-amount {
  color: #3B82F6;
}

.expenses-amount {
  color: #EF4444;
}

.box-footer {
  padding: 0 24px 24px 24px;
  text-align: center;
}

.balance-label {
  font-size: 14px;
  color: #6B7280;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.03);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}

/* Responsive Design - Only stack on very small screens */
@media (max-width: 600px) {
  .financial-boxes {
    flex-direction: column;
    margin: 0;
  }
  
  .box-container {
    padding: 8px 0;
  }
  
  .home-center-wrapper {
    padding: 16px;
  }
  
  .page-header {
    padding: 24px 0;
    margin-bottom: 32px;
  }
  
  .title-container {
    flex-direction: column;
    gap: 12px;
  }
  
  .title-icon {
    width: 56px;
    height: 56px;
  }
  
  .title-icon .v-icon {
    font-size: 28px !important;
  }
  
  .page-title {
    font-size: 32px;
  }
  
  .page-subtitle {
    font-size: 16px;
  }
  
  .modern-box {
    min-height: 160px;
  }
  
  .box-header {
    padding: 20px 20px 12px 20px;
    gap: 12px;
  }
  
  .icon-wrapper {
    width: 48px;
    height: 48px;
  }
  
  .icon-wrapper .v-icon {
    font-size: 24px !important;
  }
  
  .box-title {
    font-size: 16px;
  }
  
  .amount-text {
    font-size: 24px;
  }
  
  .amount-display {
    padding: 12px 20px;
  }
  
  .box-footer {
    padding: 0 20px 20px 20px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 28px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
  
  .amount-text {
    font-size: 20px;
  }
  
  .box-title {
    font-size: 14px;
  }
  
  .balance-label {
    font-size: 12px;
  }
}

/* For medium screens, make title smaller to fit better */
@media (max-width: 1024px) and (min-width: 601px) {
  .page-title {
    font-size: 36px;
  }
  
  .box-title {
    font-size: 16px;
  }
  
  .amount-text {
    font-size: 24px;
  }
}
</style>
